export default {"id":"bd518542","attrs":{"viewBox":"0 0 60 60","width":"60","height":"60"}}